module.exports = __webpack_public_path__ + "static/img/ME@2x.ab5fb373.jpg";